'use client';

import { BreakingNew } from '@/lib/model';
import clsx from 'clsx';
import { EmblaOptionsType, EmblaCarouselType } from 'embla-carousel';
import { Carousel, CarouselContent, CarouselItem } from '../carousel';
import AutoPlay from 'embla-carousel-autoplay';
import {
  TRT_BREKINGNEWS_WRAPPER,
  TRT_CAROUSEL_BREAKING_NEWS,
} from '../header/constant';
import { ExpandableText } from './ExpandableText';
import { useRef, useState } from 'react';
import { BreakingNewsDots } from './BreakingNewsDots';
import { cn } from '@/lib/utils';

const options: EmblaOptionsType = {
  loop: true,
  axis: 'y',
};

type Props = {
  breakingNews?: BreakingNew[];
};

export function BreakingNewsContent({ breakingNews }: Props) {
  const [expanded, setExpanded] = useState<string | undefined>(undefined);
  const [emblaApi, setCarouselApi] = useState<EmblaCarouselType | null>(null);
  const autoplay = useRef(AutoPlay({ delay: 3000 }));
  const [selectedItemHeight, setSelectedItemHeight] = useState<number>(0);

  return (
    <div
      className={cn(
        'bg-primary-blue-3 w-full flex transition-all duration-200 ease-in-out flex-row  overflow-hidden',
        {
          'max-h-[120px]': !expanded,
        },
      )}
      style={{
        ...(expanded && { maxHeight: selectedItemHeight }),
      }}
      id={TRT_BREKINGNEWS_WRAPPER}
    >
      <BreakingNewsDots emblaApi={emblaApi} breakingNews={breakingNews} />

      <div className="flex flex-col justify-center px-3 md:px-4 pt-3 pb-2 sm:pt-[11px] sm:pb-[11px] lg:pt-3 lg:pb-5 xl:pt-5 xl:pb-5">
        <Carousel
          setApi={api => setCarouselApi(api)}
          opts={options}
          plugins={[autoplay.current]}
          orientation="vertical"
          className="w-full"
          id={TRT_CAROUSEL_BREAKING_NEWS}
        >
          <CarouselContent className="mt-0 !h-full transition-[height] duration-200 ease-in-out">
            {breakingNews?.map((item, index) => {
              return (
                <CarouselItem
                  className={clsx('flex items-center pt-0 select-none')}
                  key={item.id}
                  id={`carousel-${index}`}
                >
                  <ExpandableText
                    {...item}
                    emblaApi={emblaApi}
                    setExpanded={setExpanded}
                    setSelectedItemHeight={setSelectedItemHeight}
                    expanded={expanded}
                  />
                </CarouselItem>
              );
            })}
          </CarouselContent>
        </Carousel>
      </div>
    </div>
  );
}
